import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Intro = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 2300);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="intro"
          data-testid="intro-overlay"
          className="fixed inset-0 z-[100] bg-[#020813] flex flex-col items-center justify-center"
          exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
        >
          <div className="overflow-hidden">
            <motion.p
              initial={{ y: "120%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.25 }}
              className="text-xs tracking-[0.5em] uppercase text-[#10E59A] mb-6 text-center"
            >
              Dive Deeper
            </motion.p>
          </div>
          <div className="overflow-hidden rounded-2xl">
            <motion.img
              src="/images/logo2.png"
              alt="Ocean Mind AI"
              initial={{ y: "112%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.45 }}
              className="w-[min(540px,85vw)]"
            />
          </div>
          <motion.div
            className="absolute bottom-0 left-0 h-[3px] bg-gradient-to-r from-[#00F2FE] via-[#10E59A] to-[#00F2FE]"
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 1.9, ease: "easeInOut" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
